import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, EmptyString, FormTypeAdd, PageSize, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import EditIcon from "assets/icon/EditIcon";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus, removeNonNumeric } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import { useCallApi } from "api/apiHooks";
import { useModal } from "context/ModalContext";
import Pagination from "components/Input/PaginationButton";
import { FilterCard, PagesTitle } from "components/Cards";

export default function BeneficiaryAccount(){
    let navigate = useNavigate()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchBeneficiaryList, fetchDeleteBeneficiary, fetchBankList } = useCallApi()

    const [beneficiaryList, setBeneficiaryList] = useState([])
    const [bankId, setBankId] = useState(EmptyString)
    const [bankOptions, setBankOptions] = useState([])
    const [accountNo, setAccountNo] = useState(EmptyString)
    const [accountName, setAccountName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    async function handlePageChange(newIndex) {
        try {
            showLoading()

            const res = await fetchBeneficiaryList(accountNo, accountName, bankId === EmptyString ? "0" : bankId, status, PageSize, parseInt(newIndex))

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setBeneficiaryList(res)
            setTotalPages(total);
            setPageIndex(newIndex);
        } finally {
            hideLoading();
        }
    }

    const filterEnterKeyPress = (e) => {
		if(e.key === 'Enter'){
			handlePageChange(0)
		}
	}
    const searchBtnClick = () => {
        handlePageChange(0)
    }
    const addBtnClick = () => {
        navigate("/beneficiary-account/form?beneficiaryId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (beneficiaryId) => {
        navigate("/beneficiary-account/form?beneficiaryId=" + beneficiaryId + "&formType=Edit")
    }
    const deleteBtnClick = async (beneficiaryId, status) => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            const res = await fetchDeleteBeneficiary(beneficiaryId, status)

            if (!res) return

            showSuccess()
            handlePageChange(pageIndex)
        }
    }

    useEffect(() => {
        const firstLoad = async () => {
            showLoading()

            const res = await fetchBankList('', '', '1', 10000, 0)

            if (!res) return

            let data = res.data.listData
            let tempArray = []

            tempArray.push({ label: "All", value: "" })

            for (let i = 0; i < data.length; i++){
                tempArray.push({ label: data[i].bankCode + " - " + data[i].bankName, value: String(data[i].bankId) })
            }

            setBankOptions(tempArray)
            setBankId(tempArray[0].value)

            handlePageChange(0)
        }

        firstLoad()
    },[])

    return(
        <div className="flex flex-col gap-2">
            <PagesTitle title='Beneficiary Account' />

            <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <FilterCard title='Account Name' width={'w-full sm:w-56'}>
                        <input className="input" value={accountName} onChange={(e) => { setAccountName(e.target.value) }} onKeyDown={filterEnterKeyPress} />
                    </FilterCard>
                    <FilterCard title = 'Account No' width={'w-full sm:w-56'}>
                        <input className="input" value={accountNo} onChange={(e) => { setAccountNo(e.target.value) }} onKeyDown={filterEnterKeyPress} />
                    </FilterCard>
                    <FilterCard title='Bank' width={'w-full sm:w-72'}>
                        <Dropdown value={bankId} options={bankOptions} onChange={(e) => { bankId(e.value) }} placeholder={"All"} />
                    </FilterCard>
                    <FilterCard title='Status' width={'w-full sm:w-32'}>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} />
                    </FilterCard>
                </div>
                <div>
                    <div className="flex justify-end items-end h-full">
                        <SearchButton onClick={searchBtnClick} />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="hidden sm:block mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Account Name</th>
                            <th className="font-semibold text-left px-2">Account No</th>
                            <th className="font-semibold text-left px-2">Bank</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {beneficiaryList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.accountName.toUpperCase() }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.accountNo }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.bankCode + " - " + data.bankName }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button flex gap-2" onClick={() => editBtnClick(data.beneficiaryId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.beneficiaryId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.beneficiaryId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <div className="block sm:hidden mt-5">
                <div className="flex flex-col gap-3">
                    {beneficiaryList?.data?.listData?.map((data, i) => {
                        return(
                            <div className="border rounded-md bg-white shadow flex justify-between p-3">
                                <div className="flex flex-col">
                                    <label>{data.accountName.toUpperCase()}</label>
                                    <label>{data.bankCode + " - " + data.bankName}</label>
                                    <label>{data.accountNo}</label>
                                </div>
                                <div className="flex flex-col justify-between">
                                    <button className="button flex gap-2" onClick={() => editBtnClick(data.beneficiaryId)}>
                                        <EditIcon className="w-4 fill-white" />
                                    </button>
                                    <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.beneficiaryId, data.status)}>
                                        <TrashIcon className="w-4 fill-white" />
                                    </button>
                                    <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.beneficiaryId, data.status)}>
                                        <RevisionIcon className="w-4 fill-white" />
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    )
}